export default function About(){
    return (
        <section className="about">
        <h1>ABOUT ME</h1>
            <div className="container">
                <div className="row">
                    <div className="col-md-5">
                        <p>During my six-month internship as a frontend developer, I gained valuable experience and honed my skills in creating dynamic and user-friendly websites.</p>
                    </div>
                </div>
                <div className="row">
                    <span className="col-md-6"></span>
                    <div className="col-md-5">
                        <p>As an entry-level developer, I'm enthusiastic about applying my knowledge and learning from new challenges.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-5">
                        <p>My passion for frontend development drives me to constantly seek growth opportunities and deliver impactful solutions..................</p>
                    </div>
                </div>
                <div className="row">
                    <span className="col-md-6"></span>
                    <div className="col-md-5">
                        <p>Eager to contribute to innovative projects, honing expertise in frontend development. Together, let's craft visually stunning and user-friendly websites.</p>
                    </div>
                </div>
            </div><br/>
        </section>
    );
}